import { render, staticRenderFns } from "./common-table-demo.vue?vue&type=template&id=50267d44"
import script from "./common-table-demo.vue?vue&type=script&lang=js"
export * from "./common-table-demo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports